// One attempt per user/email per app session. Durable retries live on the server.
// Never await a Supabase API call inside onAuthStateChange's auth lock.
export function createConfirmedSignupSync(sync) {
  const attempts = new Map();
  return function syncConfirmedSignup(user) {
    if (
      !user?.id ||
      !user.email ||
      !user.email_confirmed_at ||
      user.user_metadata?.newsletter_consent !== true
    )
      return Promise.resolve(false);
    const email = user.email.toLowerCase();
    if (
      user.app_metadata?.sendfox_synced_at &&
      user.app_metadata?.sendfox_sync_email === email
    )
      return Promise.resolve(true);
    const key = `${user.id}:${email}:${
      user.user_metadata.newsletter_consent_at || ""
    }`;
    if (!attempts.has(key)) {
      attempts.set(
        key,
        Promise.resolve().then(() =>
          sync(
            user.email,
            user.user_metadata.first_name || user.user_metadata.name || "",
            user.id
          )
        )
      );
    }
    return attempts.get(key);
  };
}
